import React, { useCallback } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { t } from '@/i18n'
import { IBreadcrumb, IProposal } from '@/types'
import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, makeSearchPath, proposalPath } from '@/utils'
import { useData } from './useData'
import Form from './form'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_proposal',
  },
]

const AddProposal: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { data, loading, submitting, onCancel, onSubmit } = useData({})

  const onSubmitForm = useCallback(
    (d: IProposal) => {
      onSubmit('deals/proposal/', false, res => {
        navigate(
          makeSearchPath(proposalPath, { customerId: 'customer', id: res.id }),
        )
      })(d)
    },
    [navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_proposal')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddProposal
